import script from "./automatic.vue?vue&type=script&setup=true&lang=js"
export * from "./automatic.vue?vue&type=script&setup=true&lang=js"

import "./automatic.vue?vue&type=style&index=0&id=410ba50a&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-410ba50a"]])

export default __exports__